export default __webpack_public_path__ + "b1309f8892f138383d8b0b6ff8e23463.png";